import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContenedorComponent } from '../contenedor/contenedor.component';
import { authGuardSubmodule } from '../../auth/auth.guard';

import { CatalogoCuentasComponent } from './catalogo-cuentas/catalogo-cuentas.component';
import { EstadosFinancierosComponent } from './estados-financieros/estados-financieros.component';
import { IndicadoresFinancierosComponent } from './indicadores-financieros/indicadores-financieros.component';
import { IndicadoresPerlasComponent } from './indicadores-perlas/indicadores-perlas.component';
import { IndicadoresProductividadComponent } from './indicadores-productividad/indicadores-productividad.component';
import { IndicadoresCoberturaComponent } from './indicadores-cobertura/indicadores-cobertura.component';
import { CoberturaComponent } from './cobertura/cobertura.component';
import { ActivosPonderadosComponent } from './activos-ponderados/activos-ponderados.component';
import { PlanesComponent } from './planes/planes.component';
import { SeguimientoPlanesComponent } from './seguimiento-planes/seguimiento-planes.component';
import { ReporteFinancieroComponent } from './reporte-financiero/reporte-financiero.component';

const routes: Routes = [{
  path: 'app/financiero-alerta',
  component: ContenedorComponent,
  children: [
    {path: 'catalogo-de-cuentas', component: CatalogoCuentasComponent, canActivate: [authGuardSubmodule]},
    {path: 'estados-financieros', component: EstadosFinancierosComponent, canActivate: [authGuardSubmodule]},
    {path: 'indicadores-financieros', component: IndicadoresFinancierosComponent, canActivate: [authGuardSubmodule]},
    {path: 'indicadores-perlas', component: IndicadoresPerlasComponent, canActivate: [authGuardSubmodule]},
    {path: 'indicadores-productividad', component: IndicadoresProductividadComponent, canActivate: [authGuardSubmodule]},
    {path: 'indicadores-cobertura', component: IndicadoresCoberturaComponent, canActivate: [authGuardSubmodule]},
    {path: 'cobertura', component: CoberturaComponent, canActivate: [authGuardSubmodule]},
    {path: 'activos-ponderados', component: ActivosPonderadosComponent, canActivate: [authGuardSubmodule]},
    {path: 'planes', component: PlanesComponent, canActivate: [authGuardSubmodule]},
    {path: 'seguimiento', component: SeguimientoPlanesComponent, canActivate: [authGuardSubmodule]},
    {path: 'reporte-financiero', component: ReporteFinancieroComponent, canActivate: [authGuardSubmodule]},
  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FinancieroAlertaRoutingModule { }
